import { useRef } from 'react';
/**
 * scroll into current highlight index
 */
export function useHighlightScroll(_a) {
    var containerHeighRef = _a.containerHeighRef, scrollToIndex = _a.scrollToIndex;
    var renderedItemsRef = useRef([]);
    var scrollerRef = useRef();
    var scrollToHighlightedIndex = function (prevHighlightedIndex, currHighlightedIndex, topHighlightIndex) {
        if (topHighlightIndex === void 0) { topHighlightIndex = 0; }
        if (!scrollerRef.current) {
            if (currHighlightedIndex !== topHighlightIndex) {
                requestAnimationFrame(function () {
                    scrollToIndex({
                        index: currHighlightedIndex,
                        align: 'start',
                    });
                });
            }
            return;
        }
        var scrollElm = scrollerRef.current;
        var renderedItems = renderedItemsRef.current;
        var isBackward = prevHighlightedIndex > currHighlightedIndex;
        var isForward = prevHighlightedIndex < currHighlightedIndex;
        var currentVisibleOffset = {
            start: scrollElm.scrollTop,
            stop: scrollElm.scrollTop + containerHeighRef.current,
        };
        // * when highlightedIndex is out of visible range
        if (!renderedItems.some(function (x) { return x.index === currHighlightedIndex; })) {
            scrollToIndex({
                index: currHighlightedIndex,
                align: isBackward ? 'start' : 'end',
            });
            return;
        }
        // backward
        if (isBackward) {
            var firstShouldScrollIndex = currHighlightedIndex;
            for (var i = renderedItems.length - 1; i >= 0; i--) {
                var item = renderedItems[i];
                if (item.offset <= currentVisibleOffset.start) {
                    break;
                }
                firstShouldScrollIndex = item.index;
            }
            if (currHighlightedIndex < firstShouldScrollIndex) {
                scrollToIndex({
                    index: currHighlightedIndex,
                    align: 'start',
                });
            }
            // forward
        }
        else if (isForward) {
            var lastShouldScrollIndex = currHighlightedIndex;
            for (var i = 0; i < renderedItems.length; i++) {
                var item = renderedItems[i];
                if (item.offset >= currentVisibleOffset.stop) {
                    break;
                }
                lastShouldScrollIndex = item.index;
            }
            if (currHighlightedIndex >= lastShouldScrollIndex) {
                scrollToIndex({
                    index: currHighlightedIndex,
                    align: 'end',
                });
            }
        }
        else {
            scrollToIndex({
                index: currHighlightedIndex,
                align: 'start',
            });
        }
    };
    return {
        /**
         * scroller reference
         */
        scrollerRef: scrollerRef,
        /**
         * Scroll to target highlighted index
         * @param prevHighlightedIndex previous highlightedIndex
         * @param currHighlightedIndex current highlightedIndex
         * @param topHighlightIndex top highlighIndex for check should scroll when init
         */
        scrollToHighlightedIndex: scrollToHighlightedIndex,
        /**
         * set to virtuoso `scrollerRef` prop, auto bind inner `scrollerRef`
         */
        scrollerRefFn: function (elm) { return (scrollerRef.current = elm); },
        /**
         * set to virtuoso `itemsRendered` prop, auto bind inner `renderedItemsRef`
         */
        itemsRendered: function (e) { return (renderedItemsRef.current = e); },
    };
}
/**
 * modify virtuoso style to fix safari scroll bug
 */
export function modifyVlScrollerStyle(scrollElm, position) {
    if (position === void 0) { position = 'absolute'; }
    if (scrollElm) {
        if (position) {
            var viewPortElm = scrollElm.firstChild;
            if (viewPortElm) {
                viewPortElm.style.position = position;
            }
        }
    }
}
